module.exports = __webpack_public_path__ + "img/eth_school-children-2.ca22278e.jpg";